module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjYwIiB2aWV3Qm94PSIwIDAgNjAgNjAiIHdpZHRoPSI2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMzAgMGEzMCAzMCAwIDEgMCAwIDYwIDMwIDMwIDAgMCAwIDAtNjB6bS00LjQ3NCAxMS43MWg4Ljk0OHYyMi4xMDZoOC4wODJsLTEyLjU1NiAxNC4xMTktMTIuNTU2LTE0LjExOWg4LjA4MnoiIGZpbGw9IiNkMzJiNTMiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download.svg
// module id = 170
// module chunks = 35783957827783 112966903596346 114276838955818